module.exports = __webpack_public_path__ + "img/max-envelope-repeat.1db8f798.svg";